import { TListId } from '../types/types';

export class MovedFromListHelper {
    movedFromListId: TListId;
    timer: NodeJS.Timeout;
    timeout = 20000; // 20s
    startTime: number;

    getMovedFromListId() {
        return this.movedFromListId;
    }

    setMovedFromListId(listId: TListId) {
        this.movedFromListId = listId;
        this.startTime = Date.now();
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.resetMovedFromListId();
        }, this.timeout);
    }

    getTime() {
        if (!this.startTime) return 0;
        const time = Date.now() - this.startTime;
        return Math.floor(time / 1000);
    }

    resetMovedFromListId() {
        if (this.timer) clearTimeout(this.timer);
        this.movedFromListId = null;
    }
}
